export const ACTIONS = {
  LIST_BRANDS: 'SERVICE_BRANDS__LIST_BRANDS',
  ADD_BRAND: 'SERVICE_BRANDS__ADD_BRAND',
  UPDATE_BRAND: 'SERVICE_BRANDS__UPDATE_BRAND',
  DELETE_BRAND: 'SERVICE_BRANDS__DELETE_BRAND',
};
